import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import { sanitizeForFirestore } from "./workoutReportMutations";

export function reportExerciseDocRef(organizationId, clientId, workoutId) {
  return firebase
    .firestore()
    .collection("organizations")
    .doc(organizationId)
    .collection("clients")
    .doc(clientId)
    .collection("reportExercise")
    .doc(workoutId);
}

export async function updateReportExercisePayload({ organizationId, clientId, workoutId, reportData }) {
  await reportExerciseDocRef(organizationId, clientId, workoutId).update({
    reportData: sanitizeForFirestore(reportData),
    updatedOn: firebase.firestore.FieldValue.serverTimestamp(),
  });
}
